import { createSlice } from "@reduxjs/toolkit";
import { loggedOut } from "../auth/authSlice";

// Global "which branch am I looking at" selector (handoff §13.1) - session-only
// (not persisted), so a fresh login never inherits a stale branch.
//
// `hasChosen` (2026-09-10) separates "the user has not picked anything yet"
// from "the user picked All branches" - both used to be a bare null. Until
// the user picks, useBranchFilter opens on their mother branch (the linked
// employee's own branch, from the login), falling back to All branches for an
// account with no employee. Once they pick - All included - that choice wins.
const initialState = {
  selectedBranchId: null, // null = All branches (only meaningful once hasChosen)
  hasChosen: false,
};

const branchFilterSlice = createSlice({
  name: "branchFilter",
  initialState,
  reducers: {
    branchSelected: (state, action) => {
      state.selectedBranchId = action.payload ?? null;
      state.hasChosen = true;
    },
  },
  // Logout never used to clear this, so the next person to sign in on the same
  // tab inherited the previous user's branch.
  extraReducers: (builder) => {
    builder.addCase(loggedOut, () => initialState);
  },
});

export const { branchSelected } = branchFilterSlice.actions;
export default branchFilterSlice.reducer;

export const selectSelectedBranchId = (state) => state.branchFilter.selectedBranchId;
export const selectHasChosenBranch = (state) => state.branchFilter.hasChosen;
